import React from "react";
import {__} from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import {Typography, Stack, Box} from '@lapilli-ui/components';
import {ClockIcon} from "../../../common";
import {useState} from "@wordpress/element";

const HistorySearch = ({label, onClick}) => {
    return (
        <Box id={label} className='ywcas-history-search-item' onClick={onClick} sx={{
            '&': {
                textTransform: 'capitalize',
                fontSize: '0.93rem',
                color: 'var(--wp--preset--color--contrast, #709422)',
            },
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
            }
        }}>
            <Stack direction='row' spacing={1} align='center'>
                <Stack align='center' className='ywcas-history-search-item--icon'>
                    {ClockIcon({
                        width: '20px'
                    })}
                </Stack>
                <Box className='ywcas-history-search-item--item'>
                    {label}
                </Box>
            </Stack>
        </Box>
    )
};
const HistorySearches = ({title, searches, onClick}) => {
    const [history, setHistory] = useState(searches);
    const handleClick = (event) => {
        event.stopPropagation();
        const target = event.target;
        let elementClicked = false;
        if ('ywcas-history-search-item' !== target.className) {
            const parent = target.closest('.ywcas-history-search-item');
            elementClicked = parent.id;
        } else {
            elementClicked = target.id;
        }
        if (elementClicked) {
            onClick(elementClicked);
        }
    }
    const resetHistory = () => {
        apiFetch({
            path: '/ywcas/v1/reset-user-history',
        }).then((result) => {
            setHistory([]);
        }).catch((error) => {
            console.log(error)
        });

    }
    if (history.length === 0) {
        return null;
    }
    return (
        <div className='ywcas-history-searches-wrapper'>
            <Stack direction='row' justify='space-between' align='center' className='ywcas-history-header'>
                <Typography className="ywcas-history-searches__title">{title}</Typography>
                <Box className='ywcas-delete-all-history'
                     onClick={resetHistory}>{__('Delete all', 'yith-woocommerce-ajax-search')}</Box>
            </Stack>
            {
                history && history.length > 0 && (
                    <Stack className='ywcas-history-searches-items' spacing={1}>
                        {
                            history.map(search =>
                                <HistorySearch
                                    label={search}
                                    key={search}
                                    onClick={handleClick}
                                />
                            )
                        }
                    </Stack>
                )
            }

        </div>
    )
}
export default HistorySearches;